/* =========================================================================
   MAISON SHELI — site behaviour
   Ported from the approved Claude Design's components.jsx (React) into
   vanilla JS driving the Liquid markup + real Shopify cart endpoints.
   ========================================================================= */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ── Reveal on scroll ─────────────────── */
  function initReveal() {
    var els = document.querySelectorAll('.reveal, .reveal-stagger');
    if (!els.length) return;
    if (reduceMotion || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('in');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -80px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ── Image fade-in on load ──────────────── */
  function initFadeImages() {
    document.querySelectorAll('.ms-fade-img').forEach(function (img) {
      if (img.complete) { img.classList.add('ms-loaded'); return; }
      img.addEventListener('load', function () { img.classList.add('ms-loaded'); });
    });
  }

  /* ── Editorial scroll zoom ──────────────────
     Scoped ONLY to .ms-editorial-media — the large lifestyle/editorial
     images that sit opposite a block of text (Our Story, Our Makers,
     Collection Spotlight, From the Journal, About page photos, the
     Travel Diaries featured card, and photos embedded within individual
     article bodies). Deliberately NOT applied to product cards, product
     grids, collection/category tiles, the hero carousel, article hero
     banners, or any other slider — those must stay static per design
     direction. Progressive, scroll-position-driven zoom on the inner
     .ms-media-fill image; the .ms-editorial-media wrapper keeps its own
     fixed box size + overflow:hidden, so layout never shifts and the
     enlarged image stays clipped within its section.
     scale = 1 + range * p, so p=0 (section not yet reached) is always
     an exact, unzoomed scale(1) — the visible zoom is 100% driven by
     scroll progress, reaching 1+range at p=1. */
  var editorialZoomEls = [];
  var editorialZoomRAF = 0;
  function editorialZoomTick() {
    var vh = window.innerHeight || 800;
    var isMobile = window.innerWidth <= 760;
    var range = isMobile ? 0.20 : 0.36; // mobile: 1.00x-1.20x, desktop: 1.00x-1.36x
    editorialZoomEls.forEach(function (rec) {
      var r = rec.el.getBoundingClientRect();
      if (r.bottom < -300 || r.top > vh + 300) return;
      var p = Math.max(0, Math.min(1, (vh - r.top) / (vh + r.height)));
      var scale = (1 + range * p);
      rec.inner.style.transform = 'scale(' + scale.toFixed(4) + ')';
    });
    editorialZoomRAF = requestAnimationFrame(editorialZoomTick);
  }
  function initEditorialZoom() {
    if (reduceMotion) return;
    // Auto-tag photos embedded in Travel Diary article bodies (single
    // figures + the 2/3-image caption rows) so every article gets the
    // same effect without hand-editing each article's rich text.
    document.querySelectorAll('.ms-article-body-inner figure').forEach(function (fig) {
      if (!fig.querySelector('.ms-editorial-media')) fig.classList.add('ms-editorial-media');
    });
    var wraps = document.querySelectorAll('.ms-editorial-media');
    if (!wraps.length) return;
    wraps.forEach(function (wrap) {
      var inner = wrap.querySelector('.ms-media-fill') || wrap.firstElementChild;
      if (!inner) return;
      inner.style.transform = 'scale(1)';
      editorialZoomEls.push({ el: wrap, inner: inner });
    });
    if (editorialZoomEls.length && !editorialZoomRAF) editorialZoomRAF = requestAnimationFrame(editorialZoomTick);
  }

  /* ── Announcement bar rotation ────────────────────────── */
  function initAnnouncementBar() {
    var bar = document.querySelector('.ms-ann-bar');
    if (!bar) return;
    var msgs = bar.querySelectorAll('.ms-ann-msg');
    if (msgs.length < 2) return;
    var interval = parseInt(bar.getAttribute('data-interval'), 10) || 5000;
    var idx = 0, timer = null, paused = false;
    function show(i) {
      msgs.forEach(function (m, mi) { m.classList.toggle('active', mi === i); });
    }
    function tick() { idx = (idx + 1) % msgs.length; show(idx); }
    function start() { if (timer) clearInterval(timer); timer = setInterval(tick, interval); }
    start();
    var toggle = bar.querySelector('.ms-ann-toggle');
    if (toggle) {
      toggle.addEventListener('click', function () {
        paused = !paused;
        toggle.innerHTML = paused
          ? '<span class="play">▶</span>'
          : '<span class="bars"><span></span><span></span></span>';
        toggle.setAttribute('aria-label', paused ? 'play' : 'pause');
        if (paused) { clearInterval(timer); } else { start(); }
      });
    }
  }

  /* ── Header: adaptive morph + auto-hide ────────────────────── */
  function initHeader() {
    var header = document.querySelector('.ms-nav');
    if (!header) return;
    var isAdaptive = header.classList.contains('ms-nav--adaptive');
    var isAutohide = header.classList.contains('ms-stickybar') && !isAdaptive;
    var scrollDriven = isAdaptive || isAutohide;

    // Mega panel
    var shopTrigger = header.querySelector('[data-mega-trigger]');
    var megaPanel = header.querySelector('.ms-mega-panel');
    var closeTimer = null;
    function openPanel() {
      if (closeTimer) clearTimeout(closeTimer);
      if (megaPanel) megaPanel.classList.add('open');
      header.classList.add('ms-panel-open');
    }
    function scheduleClose() {
      closeTimer = setTimeout(function () {
        if (megaPanel) megaPanel.classList.remove('open');
        header.classList.remove('ms-panel-open');
      }, 140);
    }
    if (shopTrigger && megaPanel) {
      shopTrigger.addEventListener('mouseenter', openPanel);
      shopTrigger.addEventListener('mouseleave', scheduleClose);
      megaPanel.addEventListener('mouseenter', openPanel);
      megaPanel.addEventListener('mouseleave', scheduleClose);
      shopTrigger.addEventListener('focus', openPanel);
      header.addEventListener('focusout', function (e) {
        if (!header.contains(e.relatedTarget)) { scheduleClose(); }
      });
    }
    header.querySelectorAll('.nav-link:not([data-mega-trigger])').forEach(function (link) {
      link.addEventListener('mouseenter', scheduleClose);
    });

    if (!scrollDriven) return;

    var lastY = window.scrollY || 0, accDown = 0, accUp = 0;
    var MORPH = 300;
    var HIDE_AFTER = isAdaptive ? 360 : 140;
    var RIDE = 300, REVEAL_UP = 56;
    var annBottom = 0;
    var heroOverlay = header.getAttribute('data-hero-overlay') === 'true';

    function measureAnn() {
      var ann = document.querySelector('.ms-ann-bar');
      annBottom = ann ? (ann.getBoundingClientRect().bottom + (window.scrollY || 0)) : 0;
    }
    function setVis(hidden) {
      header.setAttribute('data-vis', hidden ? 'hidden' : 'shown');
    }
    function update() {
      var y = window.scrollY || 0;
      if (isAdaptive) {
        if (annBottom === 0) measureAnn();
        var p = heroOverlay ? Math.max(0, Math.min(1, y / MORPH)) : 1;
        header.style.setProperty('--p', p.toFixed(4));
        header.style.top = Math.max(0, annBottom - y) + 'px';
      }
      if (y < HIDE_AFTER) { setVis(false); accDown = accUp = 0; lastY = y; return; }
      var dy = y - lastY;
      if (dy > 0) { accDown += dy; accUp = 0; if (accDown > RIDE) setVis(true); }
      else if (dy < 0) { accUp += -dy; accDown = 0; if (accUp > REVEAL_UP) setVis(false); }
      lastY = y;
    }
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', measureAnn);
    if (isAdaptive) {
      var tries = 0;
      (function ensure() {
        measureAnn(); update();
        if (annBottom === 0 && tries++ < 25) setTimeout(ensure, 40);
      })();
    } else {
      update();
    }
  }

  /* ── Hamburger → menu overlay ─────────────── */
  function initMenuOverlay() {
    var overlay = document.querySelector('.ms-menu-overlay');
    if (!overlay) return;
    var openers = document.querySelectorAll('[data-menu-open]');
    var closers = overlay.querySelectorAll('[data-menu-close]');
    function open() { overlay.classList.add('open'); document.documentElement.style.overflow = 'hidden'; }
    function close() { overlay.classList.remove('open'); document.documentElement.style.overflow = ''; }
    openers.forEach(function (btn) { btn.addEventListener('click', open); });
    closers.forEach(function (btn) { btn.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }

  /* ── Cart drawer ──────────────── */
  var MSCart = (function () {
    var drawer = document.querySelector('.ms-cart-drawer');

    function open() {
      if (!drawer) return;
      drawer.classList.add('open');
      document.documentElement.style.overflow = 'hidden';
    }
    function close() {
      if (!drawer) return;
      drawer.classList.remove('open');
      document.documentElement.style.overflow = '';
    }
    function refresh() {
      if (!drawer) return Promise.resolve();
      return fetch(window.routes.cart_url + '?section_id=cart-drawer')
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('.ms-cart-drawer');
          if (fresh) {
            drawer.innerHTML = fresh.innerHTML;
            bindDrawerEvents();
            updateCartCount();
          }
        });
    }
    function updateCartCount() {
      fetch(window.routes.cart_url + '.js').then(function (r) { return r.json(); }).then(function (cart) {
        document.querySelectorAll('.ms-cart-count').forEach(function (el) {
          el.textContent = '(' + cart.item_count + ')';
        });
      });
    }
    function addItem(id, qty) {
      qty = qty || 1;
      return fetch(window.routes.cart_add_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: id, quantity: qty }] }),
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data.status) { // error
            showToast(data.description || 'Could not add to bag');
            throw new Error(data.description);
          }
          return refresh().then(function () {
            open();
            showToast((data.title || 'Item') + ' · added to your bag');
            return data;
          });
        });
    }
    function changeLine(line, qty) {
      return fetch(window.routes.cart_change_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: line, quantity: qty }),
      })
        .then(function (r) { return r.json(); })
        .then(function () { return refresh(); });
    }
    function bindDrawerEvents() {
      if (!drawer) return;
      drawer.querySelectorAll('[data-cart-close]').forEach(function (b) { b.addEventListener('click', close); });
      drawer.querySelectorAll('[data-qty-minus]').forEach(function (b) {
        b.addEventListener('click', function () {
          var line = parseInt(b.getAttribute('data-line'), 10);
          var qty = parseInt(b.getAttribute('data-qty'), 10) - 1;
          changeLine(line, qty);
        });
      });
      drawer.querySelectorAll('[data-qty-plus]').forEach(function (b) {
        b.addEventListener('click', function () {
          var line = parseInt(b.getAttribute('data-line'), 10);
          var qty = parseInt(b.getAttribute('data-qty'), 10) + 1;
          changeLine(line, qty);
        });
      });
      drawer.querySelectorAll('[data-cart-remove]').forEach(function (b) {
        b.addEventListener('click', function () {
          var line = parseInt(b.getAttribute('data-line'), 10);
          changeLine(line, 0);
        });
      });
    }
    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-cart-open]');
      if (opener) { e.preventDefault(); open(); }
    });
    if (drawer) bindDrawerEvents();
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

    return { open: open, close: close, refresh: refresh, addItem: addItem, changeLine: changeLine, updateCartCount: updateCartCount };
  })();
  window.MSCart = MSCart;

  /* ── Add-to-cart forms (PDP + quick add) ────────────────── */
  function initAddToCartForms() {
    document.querySelectorAll('[data-ms-add-form]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var idInput = form.querySelector('[name="id"]');
        var qtyInput = form.querySelector('[name="quantity"]');
        var btn = form.querySelector('[type="submit"]');
        if (!idInput) return;
        var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
        if (btn) btn.disabled = true;
        MSCart.addItem(idInput.value, qty).finally(function () {
          if (btn) btn.disabled = false;
        });
      });
    });
    document.querySelectorAll('[data-ms-quick-add]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var id = btn.getAttribute('data-variant-id');
        if (!id) return;
        MSCart.addItem(id, 1);
      });
    });
  }

  /* ── Toast ──────────────────── */
  var toastTimer = null;
  function showToast(msg) {
    var toast = document.querySelector('.ms-toast');
    if (!toast) return;
    var msgEl = toast.querySelector('.ms-toast-msg');
    if (msgEl) msgEl.textContent = msg;
    toast.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toast.classList.remove('show'); }, 3400);
  }
  window.MSToast = { show: showToast };

  /* ── Newsletter modal ────────────────── */
  function initNewsletterModal() {
    var modal = document.querySelector('.ms-newsletter-modal');
    if (!modal) return;
    var delay = parseInt(modal.getAttribute('data-delay'), 10) || 6000;
    var key = 'ms-newsletter-seen';
    function open() { modal.classList.add('open'); }
    function close() { modal.classList.remove('open'); try { sessionStorage.setItem(key, '1'); } catch (e) {} }
    modal.querySelectorAll('[data-newsletter-close]').forEach(function (b) { b.addEventListener('click', close); });
    var seen = false;
    try { seen = sessionStorage.getItem(key) === '1'; } catch (e) {}
    if (!seen) { setTimeout(open, delay); }
    var form = modal.querySelector('form');
    if (form) {
      form.addEventListener('submit', function () { try { sessionStorage.setItem(key, '1'); } catch (e) {} });
    }
  }

  /* ── Accordion (single-open) ─────────────────── */
  function initAccordions() {
    document.querySelectorAll('[data-accordion]').forEach(function (group) {
      var rows = group.querySelectorAll('.ms-accordion-row');
      rows.forEach(function (row) {
        var head = row.querySelector('.ms-accordion-head');
        if (!head) return;
        head.addEventListener('click', function () {
          var willOpen = !row.classList.contains('open');
          rows.forEach(function (r) { r.classList.remove('open'); r.querySelector('.ms-accordion-head').setAttribute('aria-expanded', 'false'); });
          if (willOpen) { row.classList.add('open'); head.setAttribute('aria-expanded', 'true'); }
        });
      });
    });
  }

  /* ── PDP: gallery thumbnails + main image hover zoom + quick-add ───── */
  function initProductGallery() {
    var gallery = document.querySelector('[data-pdp-gallery]');
    if (!gallery) return;
    var main = gallery.querySelector('[data-pdp-main-img]');
    var thumbs = gallery.querySelectorAll('[data-pdp-thumb]');
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var src = thumb.getAttribute('data-full');
        var srcset = thumb.getAttribute('data-full-srcset');
        if (main && src) {
          main.setAttribute('src', src);
          if (srcset) main.setAttribute('srcset', srcset);
        }
        thumbs.forEach(function (t) { t.classList.remove('active'); });
        thumb.classList.add('active');
      });
    });
    var stage = gallery.querySelector('[data-pdp-stage]');
    var bubble = gallery.querySelector('[data-pdp-quickadd-bubble]');
    if (stage && main) {
      stage.addEventListener('mousemove', function (e) {
        var r = stage.getBoundingClientRect();
        var x = ((e.clientX - r.left) / r.width) * 100;
        var y = ((e.clientY - r.top) / r.height) * 100;
        main.style.transformOrigin = x + '% ' + y + '%';
        if (bubble) {
          bubble.style.left = (e.clientX - r.left) + 'px';
          bubble.style.top = (e.clientY - r.top) + 'px';
        }
      });
      stage.addEventListener('mouseenter', function () { main.style.transform = 'scale(1.35)'; });
      stage.addEventListener('mouseleave', function () { main.style.transform = 'scale(1)'; main.style.transformOrigin = 'center center'; });
    }
  }

  /* ── Homepage hero carousel + lightbox ───────────── */
  function initHeroCarousel() {
    var card = document.querySelector('[data-hero-carousel]');
    if (!card) return;
    var frames = card.querySelectorAll('[data-hero-frame]');
    var dots = card.querySelectorAll('[data-hero-dot]');
    if (frames.length < 2) return;
    var interval = parseInt(card.getAttribute('data-interval'), 10) || 5200;
    var idx = 0, timer = null;

    function show(i) {
      idx = i;
      frames.forEach(function (f, fi) { f.classList.toggle('active', fi === idx); });
      dots.forEach(function (d, di) { d.classList.toggle('active', di === idx); });
    }
    function next() { show((idx + 1) % frames.length); }
    function start() {
      if (reduceMotion) return;
      if (timer) clearInterval(timer);
      timer = setInterval(next, interval);
    }
    start();
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        show(parseInt(dot.getAttribute('data-index'), 10) || 0);
        start();
      });
    });

    // Lightbox
    var openBtn = card.querySelector('[data-hero-lightbox-open]');
    if (!openBtn) return;
    var lightbox = null;
    function buildLightbox() {
      var el = document.createElement('div');
      el.className = 'ms-hero-lightbox';
      el.setAttribute('role', 'dialog');
      el.setAttribute('aria-modal', 'true');
      el.innerHTML =
        '<img class="ms-hero-lightbox-img" alt="">' +
        '<button type="button" class="ms-hero-lightbox-close" aria-label="Close">✕</button>' +
        '<button type="button" class="ms-hero-lightbox-prev" aria-label="Previous">←</button>' +
        '<button type="button" class="ms-hero-lightbox-next" aria-label="Next">→</button>';
      document.body.appendChild(el);
      return el;
    }
    function lightboxShow(i) {
      var img = frames[i].querySelector('img');
      if (!img) return;
      lightbox.querySelector('.ms-hero-lightbox-img').src = img.currentSrc || img.src;
    }
    function openLightbox() {
      if (!lightbox) lightbox = buildLightbox();
      if (timer) clearInterval(timer);
      lightboxShow(idx);
      lightbox.classList.add('open');
      document.documentElement.style.overflow = 'hidden';
    }
    function closeLightbox() {
      if (!lightbox) return;
      lightbox.classList.remove('open');
      document.documentElement.style.overflow = '';
      start();
    }
    openBtn.addEventListener('click', openLightbox);
    document.addEventListener('click', function (e) {
      if (!lightbox) return;
      if (e.target.closest('.ms-hero-lightbox-close') || e.target === lightbox) closeLightbox();
      if (e.target.closest('.ms-hero-lightbox-prev')) { idx = (idx - 1 + frames.length) % frames.length; lightboxShow(idx); }
      if (e.target.closest('.ms-hero-lightbox-next')) { idx = (idx + 1) % frames.length; lightboxShow(idx); }
    });
    document.addEventListener('keydown', function (e) {
      if (!lightbox || !lightbox.classList.contains('open')) return;
      if (e.key === 'Escape') closeLightbox();
      if (e.key === 'ArrowLeft') { idx = (idx - 1 + frames.length) % frames.length; lightboxShow(idx); }
      if (e.key === 'ArrowRight') { idx = (idx + 1) % frames.length; lightboxShow(idx); }
    });
  }

  /* ── PDP: mobile sticky buy bar ───────────── */
  function initStickyBuyBar() {
    var bar = document.querySelector('.ms-pdp-sticky');
    var trigger = document.querySelector('[data-pdp-buy-row]');
    if (!bar || !trigger || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        bar.classList.toggle('show', !entry.isIntersecting);
      });
    }, { threshold: 0 });
    io.observe(trigger);
  }

  /* ── Boot ─────────────────── */
  document.addEventListener('DOMContentLoaded', function () {
    initReveal();
    initFadeImages();
    initEditorialZoom();
    initAnnouncementBar();
    initHeroCarousel();
    initHeader();
    initMenuOverlay();
    initAddToCartForms();
    initNewsletterModal();
    initAccordions();
    initProductGallery();
    initStickyBuyBar();
  });
})();
